import React from 'react';
import { Navigate } from 'react-router-dom';
import AuthService from '../services/authService';
import Intro from '../pages/Intro/Intro';

function HomeGate() {
    if (AuthService.isUsableToken()) {
        return <Navigate to="/dashboard" replace />;
    }

    return <Intro />;
}

export default HomeGate;
